import { trackUseCoupon } from '@jbhi-fi/utils/src/ga4Tracking';
import { deepEqualArrays } from './compareArraysDeep';
import { ShopifyStorefrontClient } from '../api/shopify/ShopifyStorefrontClient';

window.localStorage.setItem('coupons-updated', false);
window.localStorage.setItem('draw-coupons-initialized', false);

const storefrontClient = new ShopifyStorefrontClient();

/**
 * Draw Coupons.
 */
export const drawCoupons = async (trackingInfo, cart, basketResponse) => {
  if (
    window.Shopify.Checkout &&
    window.localStorage.getItem('draw-coupons-initialized') &&
    window.localStorage.getItem('draw-coupons-initialized') === 'true'
  ) {
    return;
  }

  // Add the dom elements
  const { coupons, requiresUpdate } = await getCoupons(trackingInfo, cart, basketResponse);
  if (requiresUpdate) {
    storefrontClient.setCartAttributes(cart.attributes, {
      _coupons: JSON.stringify(coupons),
      _couponsInWallet: JSON.stringify(basketResponse?.WalletCouponsEvaluated),
    });
  }

  updateCartCouponInputs(coupons, cart);

  const isCodeLoading = coupons.some(coupon => coupon.status === 'loading');
  if (!isCodeLoading) {
    window.localStorage.setItem('draw-coupons-initialized', true);
  }
};

/**
 * Helper function gets the coupons from cart and ensures they are up-to-date with the Baseket API
 * @returns object
 */
export const getCoupons = async (trackingInfo, cart, basketResponse) => {
  const coupons = JSON.parse(cart.attributes._coupons || '[]');
  let eventData = {};
  let trackingObj = {};
  // Do we need update our cart.attributes.Coupons from the Basket API?
  if (
    basketResponse &&
    (!window.Jbhifi.parsedCouponBasket || window.Jbhifi.parsedCouponBasket !== basketResponse.Hash)
  ) {
    const basketCoupons = coupons.map(coupon => {
      let result = basketResponse.UnusedCoupons.filter(item => {
        return item.Reference === coupon.code;
      });
      if (result.length) {
        const couponLabel = `${coupon.code} : ${result[0].Message}`;
        if (trackingInfo) {
          trackingObj = {
            coupon: couponLabel,
            wasValid: false,
            location: trackingInfo.location,
            step: trackingInfo.step,
            amountDiscounted: 0,
          };
        }

        //TODO remove old tracking
        eventData.category = 'Enhanced Ecommerce';
        eventData.action = 'Invalid Coupon';
        eventData.label = couponLabel;
        window.gtm.track('customEvent', eventData, false, false);

        return {
          code: coupon.code,
          status: result[0].MessageType.toLowerCase(),
          success: false,
          message: result[0].Message,
          name: result[0].Name,
          applicableLineItemIds: result[0].ApplicableLineItemIds,
        };
      } else {
        result = [];
        for (let i = 0; i < basketResponse.LineItems.length; i++) {
          if (basketResponse.LineItems[i].Promotions) {
            result = result.concat(
              basketResponse.LineItems[i].Promotions.filter(item => {
                return item.PromotionType === 'Coupon' && item.Reference === coupon.code;
              })
            );
          }
        }

        if (result.length) {
          const couponLabel = `${coupon.code} : ${result[0].Name}`;
          const discountAmount = result.reduce((acc, curr) => acc + curr.DiscountInc, 0);
          if (trackingInfo) {
            trackingObj = {
              coupon: couponLabel,
              wasValid: true,
              location: trackingInfo.location,
              step: trackingInfo.step,
              amountDiscounted: discountAmount,
            };
          }

          // to-do: remove old datalayer
          eventData.category = 'Enhanced Ecommerce';
          eventData.action = 'Coupon Added';
          eventData.label = couponLabel;
          window.gtm.track('customEvent', eventData, false, false);

          return {
            code: result[0].Reference,
            message: result[0].Name,
            status: 'success',
            success: true,
            amount: discountAmount,
            name: coupon.Name || result[0].Name,
            applicableLineItemIds: result[0].ApplicableLineItemIds,
          };
        }
      }
      return coupon;
    });
    window.Jbhifi.parsedCouponBasket = basketResponse.Hash;

    if (!deepEqualArrays(coupons, basketCoupons)) {
      if (trackingInfo) {
        trackUseCoupon(trackingObj);
      }
      return { coupons: basketCoupons, requiresUpdate: true };
    }
  }

  const uniqueCouponsMap = new Map();

  coupons.forEach(coupon => {
    if (!uniqueCouponsMap.has(coupon.code)) {
      uniqueCouponsMap.set(coupon.code, coupon);
    }
  });
  const uniqueCoupons = Array.from(uniqueCouponsMap.values());
  return { coupons: uniqueCoupons, requiresUpdate: false };
};

/**
 * Helper function updates form fields on the checkout form so that we don't lose the coupon value as we move from shipping to billing.
 */
async function updateCartCouponInputs(coupons, cart) {
  const orderForms = document.querySelectorAll('.main .step form');
  if (coupons.length > 0 && coupons[0].success === true && orderForms.length > 0) {
    const orderForm = orderForms[orderForms.length - 1];

    if (
      orderForm &&
      (Shopify.Checkout.step === 'contact_information' ||
        Shopify.Checkout.step === 'payment_method' ||
        Shopify.Checkout.step === 'shipping_method')
    ) {
      const hiddenCouponAttribute1 = document.createElement('input');
      hiddenCouponAttribute1.type = 'hidden';
      hiddenCouponAttribute1.name = 'checkout[attributes][_coupons]';
      hiddenCouponAttribute1.setAttribute('data-coupon-machine-value', '');

      const hiddenCouponAttribute2 = document.createElement('input');
      hiddenCouponAttribute2.type = 'hidden';
      hiddenCouponAttribute2.name = 'checkout[attributes][Coupons]';
      hiddenCouponAttribute2.setAttribute('data-coupon-human-value', '');

      orderForm.appendChild(hiddenCouponAttribute1);
      orderForm.appendChild(hiddenCouponAttribute2);
    }
  }

  if ($('input[data-coupon-machine-value]').length) {
    const human = [];
    coupons.forEach(coupon => {
      if (coupon.success) {
        human.push(`${coupon.code}`);
      }
    });

    $('input[data-coupon-machine-value]').val(JSON.stringify(coupons));
    $('input[data-coupon-human-value]').val(human.join('\r\n'));
  }

  if (cart?.attributes && cart?.attributes._coupons) {
    let updatedCoupons = [];
    const invalidCoupons = [];
    const couponsArray = JSON.parse(cart.attributes._coupons || '[]');
    couponsArray.forEach(coupon => {
      if (coupon.status === 'error' && coupon.success === false) {
        invalidCoupons.push(coupon.code);
      } else {
        updatedCoupons.push(coupon);
      }
    });
    if (updatedCoupons.length === 0) {
      updatedCoupons = '';
    } else {
      updatedCoupons = JSON.stringify(updatedCoupons);
    }

    if (invalidCoupons.length > 0) {
      const invalidCouponsElem = document.querySelector('.coupons__invalid');
      if (invalidCouponsElem) {
        const couponInput = document.getElementById('checkout_couponcode');
        if (couponInput) {
          couponInput.classList.add('has-error');
        }
      }
    }
  }
}

export const discountsReady = () => {
  return (
    window.localStorage.getItem('coupons-updated') === 'true' &&
    window.localStorage.getItem('draw-coupons-initialized') === 'true'
  );
};
